// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import './element-variables.scss'
import commonJs from './public/common'
// 语言转换
import '../static/common-css/common.css'
import '../static/font/iconfont.css'
import '../static/font/iconfont'
import i18n from './i18n/i18n';
// 引用API文件
import ajax from './public/ajax'
import filters from './public/filters';//过滤器
// JSON展示
import JsonViewer from 'vue-json-viewer'
Vue.use(JsonViewer)
// 将API方法绑定到全局
Vue.prototype.$http = ajax;      //axios请求设置
Vue.prototype.commonJs = commonJs;      //公共方法申明
Vue.config.productionTip = false
Vue.use(ElementUI)
// //在main.js定义自定义指令
// Vue.directive('highlight',function (el) {
//   let blocks = el.querySelectorAll('pre code');
//   console.log(blocks)
//   blocks.forEach((block)=>{
//     hljs.highlightBlock(block)
//   })
// })
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  filters,
  components: { App },
  template: '<App/>',
  data() {
    return {
      jsonData: {
        total: 25,
        limit: 10,
        skip: 0,
        links: {
          previous: undefined,
          next: function () {},
        }
      }
    }
  },

})



// WEBPACK FOOTER //
// ./src/main.js